import React, {Fragment} from 'react';

import HeaderUno from '../../Compartidos/HeaderUno';
import HeaderMetodos from '../../../AuxiliaresPaginas/HeaderMetodos';

//css
import { ContainerImg, ElegirLink } from '../../../Css/MetodosCSS/StyledInstruccionExplicita';
import { ContainerFlex } from '../../../Css/MetodosCSS/StyledLN2Todos';
import { ContainerEjercicio } from '../../../Css/MetodosCSS/StyledEjercicios';
import { HrMetodos } from '../../../Css/StyledHeader';

const Oraciones = () => {

    return (
        <Fragment>
            <HeaderUno />
            <HrMetodos margin='0 0.2rem 0.5rem 0.2rem' />
            <HeaderMetodos l1={"metodos/"} l2={"lecto-escritura/"} l3={"escritura/"} n1={"Métodos"} n2={"LECTURA Y ESCRITURA"} n3={"ESCRITURA"} componente={"ORACIONES"} paciente={true} bgcolor="#D05F67" color="white" width='96vw' shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="none"/>

            <ContainerFlex margintop="10rem" margintopmob="6rem">
                <ContainerEjercicio display="flex" justify="center" height="25vh">
                <ElegirLink marginright="2rem"  to={`/escritorio/metodos/lecto-escritura/escritura/oraciones/ESC11`}>
                   <ContainerImg height="170px" src={`/img/portadas/escritura11.jpg`} alt="" />
                </ElegirLink>
                <ElegirLink marginright="2rem"  to={`/escritorio/metodos/lecto-escritura/escritura/oraciones/ESC12`}>
                   <ContainerImg height="170px" src={`/img/portadas/escritura12.jpg`} alt="" />
                </ElegirLink>
                </ContainerEjercicio>
            </ContainerFlex>
        </Fragment>    
    );
}
 
export default Oraciones;